module.exports = __webpack_public_path__ + "static/media/auric-barrels.e6ca4a08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/group logos/auric-barrels.svg
// module id = 76
// module chunks = 0